/**
 * This file implements Toast messages in Tonies style:
 *
 * - create 1 global `<Container />` somewhere in your app to initialize the Toast system
 * - call `toast()` at any place in your app to display a message
 */
import React from 'react';
import { toast as toastify, ToastContainer as ToastifyContainer, } from 'react-toastify';
import * as icons from '@boxine/tonies-ui/icons';
import { colors } from '../../../components/themes/variables';
import Icon from '../../../components/Icon';
import { Fade, StyleContainer } from './styles';
const toastFunctions = {
    info: toastify.info,
    success: toastify.success,
    error: toastify.error,
};
const autoCloseTimeouts = {
    info: 5000,
    success: 5000,
    error: 10000,
};
export const ToastContainer = () => (React.createElement(StyleContainer, null,
    React.createElement(ToastifyContainer, { closeButton: 
        /** Icon breaks without this surrounding fragment */
        React.createElement(React.Fragment, null,
            React.createElement(Icon, { className: "close-icon", type: icons.exclamationMark, fill: colors.white, title: null })), closeOnClick: true, draggable: false, hideProgressBar: true, newestOnTop: false, pauseOnHover: true, position: "bottom-center", transition: Fade })));
export const toast = (message, severity = 'success', options = {}) => toastFunctions[severity](message, Object.assign({ autoClose: autoCloseTimeouts[severity] }, options));
export { toastify };
